import * as actionTypes from "../actionTypes";
import axios from "axios";

import { config } from "../../../config/config";

const searchEntriesStart = () => {
  return {
    type: actionTypes.SEARCH_ENTRIES_START,
  };
};

const searchEntriesSuccess = (entries, total) => {
  return {
    entries,
    total,
    type: actionTypes.SEARCH_ENTRIES_SUCCESS,
  };
};

const searchEntriesFailed = (err) => {
  return {
    err,
    type: actionTypes.SEARCH_ENTRIES_FAILED,
  };
};

const entriesParameters = (page, action, perPage) => {
  let params = null;
  switch (action) {
    case "search":
      return (params = `?fromScratch=true&page=${page + 1}&perPage=${perPage}`);
    case "page":
      return (params = `?page=${page + 1}&perPage=${perPage}`);
    default:
      return params;
  }
};

export const onSearchEntries = (reqBody, page, action, perPage, userRole) => {
  return async (dispatch) => {
    await dispatch(searchEntriesStart());
    const params = entriesParameters(page, action, perPage);
    try {
      const raffleEntries = await axios.post(
        `${config.prep}${params}`,
        reqBody,
        {
          headers: {
            "x-user-role": userRole,
          },
        }
      );
      await dispatch(
        searchEntriesSuccess(
          raffleEntries.data.data,
          raffleEntries.headers["x-total-count"]
        )
      );
    } catch (e) {
      await dispatch(searchEntriesFailed());
    }
  };
};

const raffleDrawStart = () => {
  return {
    type: actionTypes.RAFFLE_DRAW_START,
  };
};

const raffleDrawSuccess = (winners) => {
  return {
    winners,
    type: actionTypes.RAFFLE_DRAW_SUCCESS,
  };
};

const raffleDrawFailed = (err) => {
  return {
    err,
    type: actionTypes.RAFFLE_DRAW_FAILED,
  };
};

export const onRaffleDraw = (reqBody, success, userRole) => {
  return async (dispatch) => {
    await dispatch(raffleDrawStart());

    try {
      const raffle = await axios.post(`${config.raffle}?perPage=0`, reqBody, {
        headers: {
          "x-user-role": userRole,
        },
      });
      setTimeout(async () => {
        await dispatch(raffleDrawSuccess(raffle.data.data));
        success(true);
      }, 2000);

      setTimeout(() => {
        success(false);
      }, 7000);
    } catch (e) {
      await dispatch(raffleDrawFailed());
    }
  };
};

const saveWinnersStart = () => {
  return {
    type: actionTypes.SAVE_WINNERS_START,
  };
};

const saveWinnersSuccess = (success) => {
  return {
    success,
    type: actionTypes.SAVE_WINNERS_SUCCESS,
  };
};

const saveWinnersFailed = (err) => {
  return {
    err,
    type: actionTypes.SAVE_WINNERS_FAILED,
  };
};

export const onSaveWinners = (token) => {
  return async (dispatch) => {
    await dispatch(saveWinnersStart());

    try {
      const saveWinners = await axios.post(`${config.winners}`, token);
      await dispatch(saveWinnersSuccess(saveWinners.data.message));
    } catch (e) {
      await dispatch(saveWinnersFailed(e.response.data.message));
    }
  };
};

const fetchWinnersStart = () => {
  return {
    type: actionTypes.FETCH_WINNERS_START,
  };
};

const fetchWinnersSuccess = (winners, total) => {
  return {
    winners,
    total,
    type: actionTypes.FETCH_WINNERS_SUCCESS,
  };
};

const fetchWinnersFailed = (err) => {
  return {
    err,
    type: actionTypes.FETCH_WINNERS_FAILED,
  };
};

export const onFetchWinners = (page, perPage, userRole) => {
  return async (dispatch) => {
    await dispatch(fetchWinnersStart());

    try {
      const winners = await axios.get(
        `${config.winners}?perPage=${perPage}&page=${
          page + 1
        }&sort=-created_at`,
        {
          headers: {
            "x-user-role": userRole,
          },
        }
      );
      await dispatch(
        fetchWinnersSuccess(winners.data.data, winners.headers["x-total-count"])
      );
    } catch (e) {
      await dispatch(fetchWinnersFailed(e));
    }
  };
};

const filterWinnersStart = () => {
  return {
    type: actionTypes.FILTER_WINNERS_START,
  };
};

const filterWinnersSuccess = (filtered) => {
  return {
    filtered,
    type: actionTypes.FILTER_WINNERS_SUCCESS,
  };
};

const filterWinnersFailed = (err) => {
  return {
    err,
    type: actionTypes.FILTER_WINNERS_FAILED,
  };
};

export const onFilterWinners = (params, userRole) => {
  return async (dispatch) => {
    await dispatch(filterWinnersStart());

    try {
      let url = `${config.winners}?perPage=20&sort=-created_at`;

      if (params !== "") {
        url += `&${params}`;
      }

      const filtered = await axios.get(url, {
        headers: {
          "x-user-role": userRole,
        },
      });
      await dispatch(filterWinnersSuccess(filtered.data.data));
    } catch (e) {
      await dispatch(filterWinnersFailed(e.response.data.message));
    }
  };
};

const resetEntriesWinners = () => {
  return {
    type: actionTypes.RESET_ENTRIES_WINNERS,
  };
};

export const onResetEntriesWinners = () => {
  return async (dispatch) => {
    await dispatch(resetEntriesWinners());
  };
};

// OFFICIAL
const officialWinnersStart = () => {
  return {
    type: actionTypes.OFFICIAL_WINNER_START,
  };
};

const officialWinnersSuccess = (successMessage) => {
  return {
    successMessage,
    type: actionTypes.OFFICIAL_WINNER_SUCCESS,
  };
};

const officialWinnersFailed = (errorMessage) => {
  return {
    errorMessage,
    type: actionTypes.OFFICIAL_WINNER_FAILED,
  };
};

export const onOfficialWinner = (id, data) => {
  return async (dispatch) => {
    await dispatch(officialWinnersStart());
    try {
      const officialwinner = await axios.put(
        `${config.raffle}/winners/${id}`,
        data
      );
      await dispatch(officialWinnersSuccess(officialwinner.data.message));
      await dispatch(onFetchWinners(1));
    } catch (e) {
      await dispatch(officialWinnersFailed(e.response.data.message));
    }
  };
};

export const onResetActionMessageSuccess = () => {
  return {
    type: actionTypes.RESET_ACTION_SUCCESS_MESSAGE,
  };
};
